<div class="head" style="display: flex; align-items: center;">
    <img src="assets/images/mobilize-logo-small.png" alt="logo" width="150px">
    <a href="javascript: window.close()" class="mobilize-btn btn-orange">inchide</a>
</div>

<table border=0 cellpadding=0 cellspacing=0 width=934 style='border-collapse: collapse;table-layout:fixed;width:701pt'>
    <col class=xl75 width=87 style='mso-width-source:userset;mso-width-alt:3181;
 width:65pt'>
    <col width=250 style='mso-width-source:userset;mso-width-alt:9142;width:188pt'>
    <col width=241 style='mso-width-source:userset;mso-width-alt:8813;width:181pt'>
    <col width=193 style='mso-width-source:userset;mso-width-alt:7058;width:145pt'>
    <col width=163 style='mso-width-source:userset;mso-width-alt:5961;width:122pt'>
    <tr height=20 style='height:15.0pt'>
        <td colspan=5 height=20 class=xl78 width=934 style='border-right:.5pt solid black;
  height:15.0pt;width:701pt'>LISTA UNITATILOR PARTENERE CARE ASIGURA PRESTATII
            IN BAZA CONTRACTELOR DE INTRETINERE A AUTOVEHICULELOR
        </td>
    </tr>
    <tr class=xl73 height=20 style='height:15.0pt'>
        <td height=20 class=xl77 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>Marca
        </td>
        <td class=xl77 width=250 style='border-top:none;border-left:none;width:188pt'>Denumire
            Service
        </td>
        <td class=xl77 width=241 style='border-top:none;border-left:none;width:181pt'>Adresa
            Punct de lucru
        </td>
        <td class=xl77 width=193 style='border-top:none;border-left:none;width:145pt'>Localitate
            Punct de lucru
        </td>
        <td class=xl77 width=163 style='border-top:none;border-left:none;width:122pt'>Judet
            Punct de lucru
        </td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Allmas Dacia Service
            SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Str.&#350;tefan cel
            Mare nr.69 A
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>V&#259;lenii
            de Munte
        </td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Prahova</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Amat S.A.</td>
        <td class=xl68 style='border-top:none;border-left:none'>Bd. N. B&#259;lcescu
            nr. 204
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Pite&#351;ti</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Arge&#351;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Ana Autocenter
            SRL<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Tecuciului nr.1</td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Bârlad</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Vaslui</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Apan SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>D.N. 22 B, km. 4</td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Br&#259;ila</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Br&#259;ila</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Apan SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. George
            Co&#351;buc nr. 148
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Gala&#355;i</td>
        <td class=xl68 style='border-top:none;border-left:none'>Gala&#355;i</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Apan SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Drumul Viilor
            nr. 17 - 19
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Gala&#355;i</td>
        <td class=xl68 style='border-top:none;border-left:none'>Gala&#355;i</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Aurocar 2002 SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Alexandru Ioan
            Cuza, Nr.31E
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Alba
            Iulia
        </td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Alba</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Aurocar 2002 SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Unirii, nr.30</td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Ora&#351;tie</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Hunedoara</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Aurocar Serv SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Unirii, nr.30</td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Or&#259;&#351;tie</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Hunedoara</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Aurocar Serv SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Santuhalm, Calea
            Hunedoarei, nr. 3
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Deva</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Hunedoara</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Bara &amp; Co
            SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>&#350;oseaua
            Bor&#351;ului, nr. 22
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Oradea</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Bihor</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Becoro SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Bd.
            Independen&#355;ei nr.32
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Baia
            Mare
        </td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Maramure&#351;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Becoro SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Sat Tisa nr. 383B</td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Com.
            Bocicoiu Mare
        </td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Maramure&#351;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Class S.A.</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Botizului nr.
            43/A
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Satu Mare</td>
        <td class=xl68 style='border-top:none;border-left:none'>Satu Mare</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Cob&#259;lcescu
            SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Splaiul Unirii,
            nr. 311, sector 3
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Bucure&#351;ti</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Europa SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea &#350;agului
            nr.142/A
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Timi&#351;oara</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Timi&#351;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Europa SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Miresei Nr 1</td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Timi&#351;oara</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Timi&#351;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Group SRL<span
            style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea
            Caransebe&#351;ului nr 21
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Resita</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Caras-Severin</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Haus Tudor
            S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Soseaua de Centura,
            DN 2A - Centura d<span style='display:none'>e Vest</span></td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Constan&#355;a</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Constan&#355;a</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Marcu's Grup SA</td>
        <td class=xl68 style='border-top:none;border-left:none'>&#350;os. Pantelimon,
            Nr 450, sector 2
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Bucure&#351;ti</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Moldova SA</td>
        <td class=xl68 style='border-top:none;border-left:none'>Bd. General Nicolae
            D&#259;sc&#259;lescu, Nr 492<span style='display:none'>B</span></td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Piatra
            Neam&#355;
        </td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Neam&#355;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Moldova SA</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. &#350;tefan cel
            Mare, Nr. 256 BIS
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Roman</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Neam&#355;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Press
            Sighi&#351;oara SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Mihai Viteazu,
            Nr. 119/A
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Sighi&#351;oara</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Mure&#351;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Sima Beyer
            Import Export SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Munteniei nr.
            11
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Foc&#351;ani</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Vrancea</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Autoglobus 2000 SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea &#350;agului,
            nr. 201
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Timi&#351;oara</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Timi&#351;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Autogroup-Simo S.R.L.</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Beclean nr. 298</td>
        <td class=xl68 style='border-top:none;border-left:none'>Od. Secuiesc</td>
        <td class=xl68 style='border-top:none;border-left:none'>Harghita</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Automobile Service
            SRL<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Moldovei, Nr 22</td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Bistrita</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Bistri&#355;a
            N&#259;s&#259;ud
        </td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Automotor SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Bucure&#351;ti,
            nr.112 bis
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Craiova</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Dolj</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>BMG PIESE AUTO SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Bucuresti, nr.
            81
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Ors.
            Stef&#259;ne&#351;ti
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Arge<font
            class="font0">&#351;</font></td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Bras S.R.L.</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Silvestru, nr.36</td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Ia&#351;i</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Ia&#351;i</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Bras S.R.L.</td>
        <td class=xl68 style='border-top:none;border-left:none'>DN28, Soseaua IASI
            -Targul Frumos, KM<span style='display:none'> 10</span></td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Ia&#351;i</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Ia&#351;i</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Casa Auto Valea
            Lupului SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Sat Valea Lupului
            nr.10, DN 28
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Comuna
            Valea Lupului
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Ia&#351;i</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Casa Auto Valea
            Lupului SRL
        </td>
        <td class=xl69 width=241 style='border-top:none;border-left:none;width:181pt'>Calea
            Chi&#537;in&#259;ului, nr. 23, Spa&#539;iul P1, <br>
            în incinta Cl&#259;dirii de birouri Centro 2, parter
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Ia&#351;i</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Ia&#351;i</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>CONDORUL AUTOMOBILE
            S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Bucuresti&nbsp;
            Nr 401
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>C&#259;l&#259;ra&#351;i</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>C&#259;l&#259;ra&#351;i</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Dacia Service Cluj
            SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Turzii
            nr.253-255
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Cluj
            Napoca
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Cluj</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Dacoserv SA</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Preciziei nr. 4,
            Sector 6
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Bucure&#351;ti</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Dacoserv SA</td>
        <td class=xl68 style='border-top:none;border-left:none'>&#350;os. S&#259;laj,
            nr. 225, sector 5
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Bucure&#351;ti</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Daperom Grup Auto
            SRL<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Târgul din Vale
            nr.3A
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Pite&#351;ti</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Arge&#351;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Daren Automobile SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Republicii, Nr
            185
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Bac&#259;u</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Bac&#259;u</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Daren Automobile SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Slanicului
            nr.10A
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>One&#351;ti</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bac&#259;u</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Darex Auto SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Humorului, nr.
            96, sat &#350;cheia
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Comuna
            &#350;cheia
        </td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Suceava</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Darex Auto SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Bucovinei nr.
            62
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>R&#259;d&#259;uti</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Suceava</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Delta Plus Trading
            SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Autostrada
            Pite&#351;ti-Bucure&#351;ti, DN 65B, k<span style='display:none'>m. 3 + 750</span></td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Pite&#351;ti</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Arge<font
            class="font0">&#351;</font></td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Emilian SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Drumul DN1 km 302 +
            545
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>&#350;elimbar</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Sibiu</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Eurocar Service
            Teleorman SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Bucure&#351;ti
            nr.187
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Alexandria</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Teleorman</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Eurocar Sud SA</td>
        <td class=xl68 style='border-top:none;border-left:none'>&#350;os.
            Bucure&#351;ti, km 60
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Giurgiu</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Giurgiu</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Euro-Motor SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Bucure&#351;ti,
            nr. 132
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Bra&#351;ov</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Bra&#351;ov</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Flamicom Impex S.R.L.</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Barajului nr. 10</td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Râmnicu
            Vâlcea
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Vâlcea</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Gammis SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Brateiului nr.
            35
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Medias</td>
        <td class=xl68 style='border-top:none;border-left:none'>Sibiu</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>General Autocom
            SRL<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Euro 85 nr. 160,
            Sat M&#259;r&#259;cineni
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Comuna
            M&#259;r&#259;cineni
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Buz&#259;u</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>General Autocom
            SRL<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Munteniei, DN2,
            E85 nr. 51
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Foc&#351;ani</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Vrancea</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Grig Auto SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Regele Carol,
            nr. 54
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Dr&#259;g&#259;&#351;ani</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Vâlcea</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Grig Auto SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Profesor
            Nicolita Sanda, nr. 3
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Dr&#259;g&#259;&#351;ani</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Vâlcea</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>IATSA Gala&#355;i
            SA<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Drumul Viilor
            nr.6
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Gala&#355;i</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Gala&#355;i</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>International Service
            Slobozia SA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>&#350;os.
            Bucure&#351;ti-Constan&#355;a Km110
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Slobozia</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Ialomita</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Laz&#259;r Service
            Com S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Aleea Victoriei nr. 1</td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Târgu
            Jiu
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Gorj</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Laz&#259;r Service
            Com S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Târgu Jiului
            nr. 128
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Drobeta-Turnu Severin</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Mehedin&#355;i</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Materom Auto Expert
            S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>&#350;oseaua
            Sighi&#351;oarei, Nr 411
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Corunca</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Mure&#351;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Mavexim SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Aleea Mân&#259;stirea
            Dealu nr. 197, Sat Val<span style='display:none'>ea Voievozilor</span></td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Targoviste</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Dâmbovi&#355;a</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Meridian Nord SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Bd. Pipera nr. 1/IX</td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Voluntari</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Ilfov</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Meridian Sud Invest
            SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Turnu
            M&#259;gurele Nr 58-60, sector 4<span style='mso-spacerun:yes'> </span></td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Bucure&#351;ti</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Meridian Vest S.R.L.</td>
        <td class=xl68 style='border-top:none;border-left:none'>Bd. Iuliu Maniu nr.
            319-329, Sector 6
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Bucure&#351;ti</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Mida SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Bra&#351;ovului,
            Nr 67
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Miercurea-Ciuc</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Harghita</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Mida SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>DN 12, km 8, F.N.</td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Sfântu
            Gheorghe
        </td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Covasna</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>MTR AUTO SERVICE SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Strada
            H&#258;RMANULUI, Nr. 49A
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Bra&#351;ov</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Bra&#351;ov</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Nesty Auto Service
            SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Sos Berceni nr.80,
            sector 4
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Bucure&#351;ti</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Nicogel Serv S.R.L.</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Poligonului nr.
            1
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Ploie&#351;ti</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Prahova</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Poliserv JG (PJG)
            S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Strandului, 146</td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Ploie&#351;ti</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Prahova</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Poliserv JG (PJG)
            S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Centura de Est, nr.21</td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Ploie&#351;ti</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Prahova</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Redac S.R.L.</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. R<font
            class="font0">âului nr. 387</font></td>
        <td class=xl68 style='border-top:none;border-left:none'>Craiova</td>
        <td class=xl68 style='border-top:none;border-left:none'>Dolj</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Rent Car Service
            Litoral SRL<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. I. C.
            Br&#259;tianu, nr. 251
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Constan&#355;a</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Constan&#355;a</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Rent Car Service
            Litoral SRL<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>&#350;oseaua
            Constan&#355;ei, Nr. 57A-57B
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Mangalia</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Constan&#355;a</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Rent Car Service
            Litoral SRL<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>B-dul Tomis, nr. 393</td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Constan&#355;a</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Constan&#355;a</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Seda-Service SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Buze&#351;ti, nr
            8
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Caracal</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Olt</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Service Auto Serus
            S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>B-dul Timi<font
            class="font0">&#351;oara nr. 60E, Sector 6</font></td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Bucure&#351;ti</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Service Auto Serus
            S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>&#350;os. de
            Centur&#259; nr. 17, T57/6,P8,9,10,11<span style='display:none'>,12/2</span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Comuna Chiajna</td>
        <td class=xl68 style='border-top:none;border-left:none'>Ilfov</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Service Auto Serus
            S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Tarlaua 12, Parcelele
            80/1-80/43
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Comuna
            Blejoi
        </td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Prahova</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Service Automobile SA</td>
        <td class=xl68 style='border-top:none;border-left:none'>Bd. 22 Decembrie, nr.
            129
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Deva</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Hunedoara</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Service Automobile SA</td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Timisoarei FN</td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Caransebe&#351;</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Cara&#351;-Severin</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Service Automobile
            SA<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Calea
            Transilvaniei nr.60
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Câmpulung
            Moldovenesc
        </td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Suceava</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Service Automobile
            SRL<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Sat R&#259;carii de
            Sus, Str. Prim&#259;verii, Nr.5
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Filia&#351;i</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Dolj</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Service Automobile
            SRL<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Severinului,
            Nr.225
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Craiova</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Dolj</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Service Automobile
            Turda SA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Clujului D.e.
            15, FN
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Turda</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Cluj</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Sicaro SA</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Harmanului, nr.
            49
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Bra&#351;ov</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Bra&#351;ov</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Simpo Trans Service
            SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Sos.
            Bucure&#351;ti-Urziceni nr. 21, DN2, km<span style='display:none'>21</span></td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Afuma&#355;i</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Ilfov</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Simpo Trans Service
            SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>&#350;os. Colentina
            345, Sector 2
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Bucure&#351;ti</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Star Service
            S.A.<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Barajului, FN</td>
        <td class=xl68 style='border-top:none;border-left:none'>Tulcea</td>
        <td class=xl68 style='border-top:none;border-left:none'>Tulcea</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>TARGOVISTE PREMIUM
            AUTO 2012 SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Sat Viforata, Str.
            Aleea Sinaia, nr. 21-23
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Comuna
            Aninoasa
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Dâmbovi&#355;a</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Transilvania
            Automobile S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>DN1, km. 303+505, FN,
            Sat &#350;elimb&#259;r
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Comuna
            &#350;elimb&#259;r
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Sibiu</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Tridex Service S.R.L.</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Mihai Eminescu,
            nr.8
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>C&#259;t&#259;m&#259;r&#259;&#537;ti
            Deal
        </td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Boto&#351;ani</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Union Motors Car
            Sales S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>&#350;os.
            Bucure&#351;ti-Ploie&#351;ti nr. 145, Sector 1
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Bucure&#351;ti</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Verbi<font
            class="font0">&#355;&#259; S.R.L.</font></td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Aurel Vlaicu
            nr. 282/1
        </td>
        <td class=xl72 style='border-top:none;border-left:none'>Arad</td>
        <td class=xl72 style='border-top:none;border-left:none'>Arad</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>DACIA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Xandor Grup SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str.
            Manole&#351;ti<span style='mso-spacerun:yes'>  </span>Deal, nr. 33
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Boto&#351;ani</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Boto&#351;ani</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Amat S.A.</td>
        <td class=xl68 style='border-top:none;border-left:none'>Bd. N. B<font
            class="font0">&#259;lcescu nr. 204</font></td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Pite<font
            class="font0">&#351;ti</font></td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Arge<font
            class="font0">&#351;</font></td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Apan SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>D.N. 22 B, km. 4</td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Br&#259;ila</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Br&#259;ila</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Apan SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. George
            Co&#351;buc nr. 148
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Gala&#355;i</td>
        <td class=xl68 style='border-top:none;border-left:none'>Gala&#355;i</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Apan SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Drumul Viilor
            nr. 17 - 19
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Gala&#355;i</td>
        <td class=xl68 style='border-top:none;border-left:none'>Gala&#355;i</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Aurocar 2002 SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Alexandru Ioan
            Cuza, Nr.31E
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Alba
            Iulia
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Alba</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Bara &amp; Co
            SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>&#350;oseaua
            Bor&#351;ului, nr. 22
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Oradea</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bihor</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Becoro SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Bd.
            Independen&#355;ei nr.32
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Baia
            Mare
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Maramure&#351;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Class S.A.</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Botizului nr.
            43/A
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Satu
            Mare
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Satu
            Mare
        </td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Cob&#259;lcescu
            SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Splaiul Unirii,
            nr. 311, sector 3
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Bucure&#351;ti</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Europa SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea &#350;agului
            nr.142/A
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Timi&#351;oara</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Timi&#351;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Haus Tudor
            S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Soseaua de Centura,
            DN 2A - Centura d<span style='display:none'>e Vest</span></td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Constan&#355;a</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Constan&#355;a</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Marcu's Grup SA</td>
        <td class=xl68 style='border-top:none;border-left:none'>&#350;os. Pantelimon,
            Nr 450, sector 2
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Bucure&#351;ti</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Moldova SA</td>
        <td class=xl68 style='border-top:none;border-left:none'>Bd. General Nicolae
            D&#259;sc&#259;lescu, Nr 492<span style='display:none'>B</span></td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Piatra
            Neam&#355;
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Neam&#355;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Moldova SA</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. &#350;tefan cel
            Mare, Nr. 256 BIS
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Roman</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Neam&#355;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Autoglobus 2000 SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea &#350;agului,
            nr. 201
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Timi&#351;oara</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Timi&#351;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Autogroup-Simo S.R.L.</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Beclean nr. 298</td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Od.
            Secuiesc
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Harghita</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Automobile Service
            SRL<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Moldovei, Nr 22</td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Bistrita</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bistri&#355;a
            N&#259;s&#259;ud
        </td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Bras S.R.L.</td>
        <td class=xl68 style='border-top:none;border-left:none'>DN28, Soseaua IASI
            -Targul Frumos, KM<span style='display:none'> 10</span></td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Ia&#351;i</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Ia&#351;i</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Casa Auto Valea
            Lupului SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Sat Valea Lupului
            nr.10, DN 28
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Comuna
            Valea Lupului
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Ia&#351;i</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Casa Auto Valea
            Lupului SRL
        </td>
        <td class=xl69 width=241 style='border-top:none;border-left:none;width:181pt'>Calea
            Chi&#537;in&#259;ului, nr. 23, Spa&#539;iul P1, <br>
            în incinta Cl&#259;dirii de birouri Centro 2, parter
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Ia&#351;i</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Ia&#351;i</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>CONDORUL AUTOMOBILE
            S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Bucuresti&nbsp;
            Nr 401
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>C&#259;l&#259;ra&#351;i</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>C&#259;l&#259;ra&#351;i</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Coramex SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Bd. 22 Decembrie nr.
            127A
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Deva</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Hunedoara</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Dacia Service Cluj
            SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Turzii
            nr.253-255
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Cluj
            Napoca
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Cluj</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Dacoserv SA</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Preciziei nr. 4,
            Sector 6
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Bucure&#351;ti</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Daren Automobile SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Republicii, Nr
            185
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Bac&#259;u</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bac&#259;u</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Daren Automobile SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Slanicului
            nr.10A
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>One&#351;ti</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bac&#259;u</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Darex Auto SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Humorului, nr.
            96, sat &#350;cheia
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Comuna
            &#350;cheia
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Suceava</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Darex Auto SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Bd. Mihai Eminescu,
            nr. 2
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Boto&#351;ani</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Boto&#351;ani</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Eurocar Service
            Teleorman SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Bucure&#351;ti
            nr.187
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Alexandria</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Teleorman</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Euro-Motor SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Bucure&#351;ti,
            nr. 132
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Bra&#351;ov</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bra&#351;ov</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Flamicom Impex S.R.L.</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Barajului nr. 10</td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>R<font
            class="font0">âmnicu Vâlcea</font></td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>V<font
            class="font0">âlcea</font></td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>General Autocom
            SRL<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. EURO 85 nr.
            39-41, Sat M&#259;r&#259;cineni
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Comuna
            M&#259;r&#259;cineni
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Buz&#259;u</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>General Autocom
            SRL<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Munteniei, DN2,
            E85 nr. 51
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Foc&#351;ani</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Vrancea</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>International Service
            Slobozia SA
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>&#350;os.
            Bucure&#351;ti-Constan&#355;a Km110
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Slobozia</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Ialomita</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Laz&#259;r Service
            Com S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Aleea Victoriei nr. 1</td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>T<font
            class="font0">ârgu Jiu</font></td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Gorj</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Laz&#259;r Service
            Com S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Târgu Jiului
            nr. 128
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Drobeta-Turnu Severin</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Mehedin&#355;i</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Materom Auto Expert
            S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>&#350;oseaua
            Sighi&#351;oarei, Nr 411
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Corunca</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Mure&#351;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Mavexim SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Aleea Mân&#259;stirea
            Dealu nr. 197, Sat Val<span style='display:none'>ea Voievozilor</span></td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Targoviste</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Dâmbovi&#355;a</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Meridian Nord SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Bd. Pipera nr. 1/IX</td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Voluntari</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Ilfov</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Meridian Sud Invest
            SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Turnu
            M&#259;gurele Nr 58-60, sector 4<span style='mso-spacerun:yes'> </span></td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Bucure&#351;ti</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Meridian Vest S.R.L.</td>
        <td class=xl68 style='border-top:none;border-left:none'>Bd. Iuliu Maniu nr.
            319-329, Sector 6
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Bucure&#351;ti</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Mida SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Bra&#351;ovului,
            Nr 67
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Miercurea-Ciuc</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Harghita</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Mida SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>DN 12, km 8, F.N.</td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Sfântu
            Gheorghe
        </td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Covasna</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Mival Class S.R.L.</td>
        <td class=xl68 style='border-top:none;border-left:none'>P-&#355;a Montreal,
            Nr. 10, Cl&#259;direa Principa<span style='display:none'>l&#259; WTCB,
  Spatiul Garage, Parking 1, Sector 1</span></td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Bucure&#351;ti</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>MTR AUTO SERVICE SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Strada
            H&#258;RMANULUI, Nr. 49A
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Bra&#351;ov</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Bra&#351;ov</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Nicogel Serv S.R.L.</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Poligonului nr.
            1
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Ploie&#351;ti</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Prahova</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Poliserv JG (PJG)
            S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Strandului, 146</td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Ploie&#351;ti</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Prahova</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Poliserv JG (PJG)
            S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Centura de Est, nr.21</td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Ploie&#351;ti</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Prahova</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Redac S.R.L.</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. R<font
            class="font0">âului nr. 387</font></td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Craiova</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Dolj</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Service Auto Serus
            S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>B-dul Timi<font
            class="font0">&#351;oara nr. 60E, Sector 6</font></td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Bucure&#351;ti</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Service Auto Serus
            S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>&#350;os. de
            Centur&#259; nr. 17, T57/6,P8,9,10,11<span style='display:none'>,12/2</span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Comuna Chiajna</td>
        <td class=xl68 style='border-top:none;border-left:none'>Ilfov</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Service Auto Serus
            S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Tarlaua 12, Parcelele
            80/1-80/43
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Comuna
            Blejoi
        </td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Prahova</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Service Automobile
            SRL<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Severinului,
            Nr.225
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Craiova</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Dolj</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Sicaro SA</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Harmanului, nr.
            49
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Bra&#351;ov</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bra&#351;ov</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Star Service
            S.A.<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Barajului, FN</td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Tulcea</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Tulcea</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Total Service Interna<font
            class="font0">&#355;ional S.R.L.</font></td>
        <td class=xl68 style='border-top:none;border-left:none'>B-dul Tomis nr. 393</td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Constan&#355;a</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Constan&#355;a</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Total Service Interna<font
            class="font0">&#355;ional S.R.L.</font></td>
        <td class=xl68 style='border-top:none;border-left:none'>B-dul I. C.
            Br&#259;tianu nr. 251
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Constan&#355;a</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Constan&#355;a</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Transilvania
            Automobile S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>DN1, km. 303+505, FN,
            Sat &#350;elimb&#259;r
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Comuna
            &#350;elimb&#259;r
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Sibiu</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Tridex Service S.R.L.</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Mihai Eminescu,
            nr.8
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>C&#259;t&#259;m&#259;r&#259;&#537;ti
            Deal
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Boto&#351;ani</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Union Motors Car
            Sales S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>&#350;<font
            class="font0">os. Bucure&#351;ti-Ploie&#351;ti nr. 145, Sector 1</font></td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Bucure&#351;ti</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>RENAULT
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Verbi<font
            class="font0">&#355;&#259; S.R.L.</font></td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Aurel Vlaicu
            nr. 282/1
        </td>
        <td class=xl72 style='border-top:none;border-left:none'>Arad</td>
        <td class=xl72 style='border-top:none;border-left:none'>Arad</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Apan SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>D.N. 22 B, km. 4</td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Br&#259;ila</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Br&#259;ila</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Apan SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Drumul Viilor
            nr. 17 - 19
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Gala&#355;i</td>
        <td class=xl68 style='border-top:none;border-left:none'>Gala&#355;i</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Bara &amp; Co
            SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>&#350;oseaua
            Bor&#351;ului, nr. 22
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Oradea</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bihor</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Becoro SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Bd.
            Independen&#355;ei nr.32
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Baia
            Mare
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Maramure&#351;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Cob&#259;lcescu
            SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Splaiul Unirii,
            nr. 311, sector 3
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Bucure&#351;ti</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Europa SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea &#350;agului
            nr.142/A
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Timi&#351;oara</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Timi&#351;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Europa SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Miresei Nr 1</td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Timi&#351;oara</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Timi&#351;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Auto Moldova SA</td>
        <td class=xl68 style='border-top:none;border-left:none'>Bd. General Nicolae
            D&#259;sc&#259;lescu, Nr 492<span style='display:none'>B</span></td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Piatra
            Neam&#355;
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Neam&#355;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Badsi Impex S.R.L.</td>
        <td class=xl68 style='border-top:none;border-left:none'>&#350;os. Pipera nr.
            50A, Sector 2
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Bucure&#351;ti</td>
        <td class=xl68 style='border-top:none;border-left:none'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Casa Auto Valea
            Lupului SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Sat Valea Lupului
            nr.10, DN 28
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Comuna
            Valea Lupului
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Ia&#351;i</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Dacia Service Cluj
            SRL
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Turzii
            nr.253-255
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Cluj
            Napoca
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Cluj</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Daperom Grup Auto
            SRL<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Târgul din Vale
            nr.3A
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Pite&#351;ti</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Arge&#351;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Daperom Grup Auto
            SRL<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. IOAN S.GHEORGHE,
            nr.1
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Pite&#351;ti</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Arge&#351;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Daren Automobile SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Republicii, Nr
            185
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Bac&#259;u</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bac&#259;u</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Darex Auto SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Humorului, nr.
            96, sat &#350;cheia
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Comuna
            &#350;cheia
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Suceava</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Euro-Motor SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Bucure&#351;ti,
            nr. 132
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Bra&#351;ov</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bra&#351;ov</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Euro-Motor SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Bucure&#351;ti
            nr. 240
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Bra&#351;ov</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bra&#351;ov</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Flamicom Impex S.R.L.</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Barajului nr. 10</td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>R<font
            class="font0">âmnicu Vâlcea</font></td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>V<font
            class="font0">âlcea</font></td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>General Autocom
            SRL<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Euro 85 nr. 160,
            Sat M&#259;r&#259;cineni
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Comuna
            M&#259;r&#259;cineni
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Buz&#259;u</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>General Autocom
            SRL<span style='mso-spacerun:yes'> </span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Munteniei, DN2,
            E85 nr. 51
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Foc&#351;ani</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Vrancea</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Laz&#259;r Service
            Com S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Aleea Victoriei nr. 1</td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>T<font
            class="font0">ârgu Jiu</font></td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Gorj</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Materom Auto Expert
            S.R.L.
        </td>
        <td class=xl71 width=241 style='border-top:none;border-left:none;width:181pt'>Str.
            Budiului nr. 2/A<span style='mso-spacerun:yes'> </span></td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Tg.
            Mure&#351;
        </td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Mure&#351;</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Mida SRL</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. Bra&#351;ovului,
            Nr 67
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Miercurea-Ciuc</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Harghita</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Redac S.R.L.</td>
        <td class=xl68 style='border-top:none;border-left:none'>Str. R<font
            class="font0">âului nr. 387</font></td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Craiova</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Dolj</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Service Auto Serus
            S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>B-dul Timi&#351;oara
            nr. 87, Sector 6
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Bucure&#351;ti</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Bucure&#351;ti</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Service Auto Serus
            S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>&#350;os. de
            Centur&#259; nr. 17, T57/6,P8,9,10,11<span style='display:none'>,12/2</span></td>
        <td class=xl68 style='border-top:none;border-left:none'>Comuna Chiajna</td>
        <td class=xl68 style='border-top:none;border-left:none'>Ilfov</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Service Auto Serus
            S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Tarlaua 12, Parcelele
            80/1-80/43
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Comuna
            Blejoi
        </td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Prahova</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Service Automobile SA</td>
        <td class=xl68 style='border-top:none;border-left:none'>Bd. 22 Decembrie, nr.
            129
        </td>
        <td class=xl70 width=193 style='border-top:none;border-left:none;width:145pt'>Deva</td>
        <td class=xl70 width=163 style='border-top:none;border-left:none;width:122pt'>Hunedoara</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Total Service Interna<font
            class="font0">&#355;ional S.R.L.</font></td>
        <td class=xl68 style='border-top:none;border-left:none'>B-dul Tomis nr. 393</td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Constan&#355;a</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Constan&#355;a</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Total Service Interna<font
            class="font0">&#355;ional S.R.L.</font></td>
        <td class=xl68 style='border-top:none;border-left:none'>B-dul I. C.
            Br&#259;tianu nr. 251
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Constan&#355;a</td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Constan&#355;a</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Transilvania
            Automobile S.R.L.
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>DN1, km. 303+505, FN,
            Sat &#350;elimb&#259;r
        </td>
        <td class=xl69 width=193 style='border-top:none;border-left:none;width:145pt'>Comuna
            &#350;elimb&#259;r
        </td>
        <td class=xl69 width=163 style='border-top:none;border-left:none;width:122pt'>Sibiu</td>
    </tr>
    <tr class=xl74 height=20 style='mso-height-source:userset;height:15.0pt'>
        <td height=20 class=xl76 width=87 style='height:15.0pt;border-top:none;
  width:65pt'>NISSAN
        </td>
        <td class=xl68 style='border-top:none;border-left:none'>Verbi<font
            class="font0">&#355;&#259; S.R.L.</font></td>
        <td class=xl68 style='border-top:none;border-left:none'>Calea Aurel Vlaicu
            nr. 282/1
        </td>
        <td class=xl72 style='border-top:none;border-left:none'>Arad</td>
        <td class=xl72 style='border-top:none;border-left:none'>Arad</td>
    </tr>
    <tr height=0 style='display:none'>
        <td width=87 style='width:65pt'></td>
        <td width=250 style='width:188pt'></td>
        <td width=241 style='width:181pt'></td>
        <td width=193 style='width:145pt'></td>
        <td width=163 style='width:122pt'></td>
    </tr>
</table>


